import * as CL from '@design-system/component-library';
import { pushOECEmbedLinkEventToDataLayer } from '../../../common/analytics.js';
import { editMsg, t } from '../../../common/i18n/index.js';
import { useConfig } from '../../../public/site/ConfigProvider.js';
import { EditingSection } from '../billingAccountDetailsEnums.js';
import { GridColumn } from './GridColumn.js';

export interface EditButtonProps {
  setNewEditingSection: () => void;
  editingSection: EditingSection;
  editableInClassic?: boolean;
  name: string;
}

export const EditBillingAccountButton = ({
  setNewEditingSection,
  editableInClassic,
  name,
  editingSection,
}: EditButtonProps) => {
  const { classicSiteUrl } = useConfig();
  const classicSiteBillingDetailsUrl = `${classicSiteUrl}/laskutustiedot`;

  return editableInClassic ? (
    <GridColumn className="of-billing-account-details form-column view-field edit-button">
      <CL.Button
        color="light"
        onClick={() => {
          pushOECEmbedLinkEventToDataLayer(classicSiteBillingDetailsUrl);
          window.open(classicSiteBillingDetailsUrl, '_blank');
        }}
        iconPosition="right"
        icon={<CL.Icon icon="external-link" color="blue-800" />}
      >
        {t.NVPK(editMsg)}
      </CL.Button>
    </GridColumn>
  ) : (
    <GridColumn className="of-billing-account-details form-column view-field edit-button">
      <CL.Button
        id={`${name}Edit`}
        color="light"
        onClick={() => setNewEditingSection()}
        disabled={editingSection !== EditingSection.NONE}
      >
        {t.NVPK(editMsg)}
      </CL.Button>
    </GridColumn>
  );
};
